import React from 'react';
import { Button, Modal, Tooltip } from '@roo/roo';
import QRCode from 'qrcode';
import { getCopyUrl, IQrcodeButtonProps } from '../api';

const { useState } = React;

const Index = (props: IQrcodeButtonProps) => {
    const { id } = props;
    const [disable, setDisable] = useState(false);
    const [visible, setVisible] = useState(false);
    const [imgUrl, setImgUrl] = useState('');

    const handleClick = () => {
        setDisable(true);
        getCopyUrl({ itemId: id })
            .then(res => {
                const url = res.data;
                QRCode.toDataURL(url, (err, url) => {
                    if (err) throw err;
                    console.log(url);
                    setImgUrl(url);
                    setVisible(true);
                });
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <>
            <Button onClick={handleClick} type="text" disabled={disable}>
                商品二维码
            </Button>
            <Tooltip
                content={
                    <>
                        <p>1.您可以将此二维码截图发给商家，让商家扫码并完成订单支付；</p>
                        <p>
                            2.或者由服务商销售人员扫此二维码后以卡片形式并分享给商家，商家点击分享后的链接完成订单支付；
                        </p>
                        <p>——以上两种方式均支持客户的定向分配。</p>
                    </>
                }
                effect="light"
            >
                <span className="ques-tip">?</span>
            </Tooltip>
            <Modal
                title="商品二维码"
                visible={visible}
                showCancelButton={false}
                showConfirmButton={false}
                onCancel={() => {
                    setVisible(false);
                }}
                style={{ width: 200 }}
            >
                <img src={imgUrl} />
            </Modal>
        </>
    );
};

export default Index;
